export const colorsSeverity = {
  critical: "#D73939",
  high: "#DF732C",
  medium: "#4154AF",
  low: "#454F5E",
  unknown: "#a2a3a4",
}

// Text tints for the outline severity chips: lightened per-severity for dark theme
// (the raw palette is too dark to read as text on near-black), raw/darkened for light.
export const chipTintDark = {
  critical: "rgb(235,100,100)",
  high: "rgb(235,145,85)",
  medium: "rgb(130,150,235)",
  low: "rgb(150,165,185)",
  unknown: "rgba(255,255,255,0.55)",
}
export const chipTintLight = {
  critical: "#C22F2F",
  high: "#C4611F",
  medium: "#4154AF",
  low: "#454F5E",
  unknown: "rgba(0,0,0,0.5)",
}

export const severityTypes = ["critical", "high", "medium", "low", "unknown"];
